import { Button, Transition } from "@mantine/core";

interface ProactiveSuggestionButtonProps {
    onClick: (button: string) => void;
    shouldShow: boolean;
    suggestion: string;
}

export function ProactiveSuggestionButton({ onClick, shouldShow, suggestion }: ProactiveSuggestionButtonProps) {
    return (
        <Transition duration={400} mounted={shouldShow} transition="slide-left" timingFunction="ease">
            {(transitionStyles) => (
                <Button
                    color="dark.7"
                    size="xs"
                    key={suggestion}
                    onClick={() => onClick(suggestion)}
                    style={{ ...transitionStyles }}
                >
                    {suggestion}
                </Button>
            )}
        </Transition>
    );
}
